import { Locale } from "@/Common/Models/Localization/Locale";

export class LoginLanguageHelper {
    public static getFirstLanguage(lang: string): Locale {
        switch ((lang || "").toLowerCase()) {
            case "fr":
            case "fr-fr":
            case "fr-ca":
                return Locale.fr;

            case "en":
            case "en-us":
            case "en-ca":
                return Locale.en;

            case "es":
            case "es-mx":
                return Locale.es;

            default:
                return Locale.en;
        }
    }
}
